module.exports = __webpack_public_path__ + "media/images/homepage_images/cover_3-797bf558cdd7762430ae6dae6933214f.jpeg";